import {
  ERROR_CLEAR,
  ERROR_CLEAR_ALL,
  ERROR_SET,
  SET,
  CLEAR
} from './action-types'

export function set (key, data) {
  return {
    type: SET,
    payload: { [key]: data }
  }
}

export function clear () {
  return {
    type: CLEAR
  }
}

export function setError (error) {
  return {
    type: ERROR_SET,
    payload: error
  }
}

export function clearError (key) {
  return {
    type: ERROR_CLEAR,
    payload: key
  }
}

export function clearAllErrors () {
  return {
    type: ERROR_CLEAR_ALL
  }
}

const actionCreators = Object.assign({}, { set, clear, setError, clearError, clearAllErrors })

export default actionCreators
